import React from "react";
// import About from "./About";
import About from "../features/about/About";
import Products from "./Products";
import NutritionFacts from "./NutritionFacts";
import MacaDishes from "./MacaDishes";
import Contact from "./Contact";
import Navbar1 from "./ui/navbar1/Navbar1";
import Navbar2 from "./ui/navbar2/Navbar2";
import Hero from "../features/hero/Hero";
import Footer from "./ui/footer/Footer";

export default class MacaVanPhucApp extends React.Component {
  render() {
    return (
      <div className="app-layout">
        {/* <Navbar1 /> */}
        <Navbar2 />
        <Hero />
        {/* <About /> */}
        <About />
        <Products />
        <NutritionFacts />
        <MacaDishes />
        <Contact />
        <Footer />
      </div>
    );
  }
}
